import { Component } from '@angular/core';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'general-information',
	template: require('./general-information.component.html'),
	host: { class: 'flex-column min-height-full-vh-bg-color' },
})
export class GeneralInformationComponent {
	public isRebrading = AppSettings.isRebrading;
}
